  function trimTrailing(str){
    return str.replace(/^\s+|\s+$/g,'');
  }
  
  function populatePakkeShopSelect(items) {
      var str = "<option id='' value=''></option>";
      var shops;
            
      shops = items.sort( predicatBy("ZipCode") );  
            
      $.each(shops, function () {
        var shop_number = trimTrailing(this["Number"]);
        var company_name = trimTrailing(this["CompanyName"]);
        var zip = trimTrailing(this["ZipCode"]);
        
        str = str + '<option id="' + shop_number + '" value= '+ shop_number + '>' + zip + " " + company_name + '</option>';
      });
      $("#pakke-shop").html(str);
  }
  
  function predicatBy(prop){
     return function(a,b){      
        aa = trimTrailing(a[prop]);
        bb =   trimTrailing(b[prop]);
        
        if( aa > bb){
            return 1;
        }else if( aa < bb ){
            return -1;
        }
        return 0;
     }
  }
  
  
  function populatePakkeShopAddresses() {
      var str = "";
      var shops = pakke_shop_json_array.shop;
            
      $.each(shops, function () {
         var shop_number = trimTrailing(this["Number"])
          var company_name = this["CompanyName"].replace(/^\s+|\s+$/g,'');
          address = 
                  "<span id='pke-name_" + shop_number + "'>" + trimTrailing(this["CompanyName"]) +"</span><br/>" +
                  "<span id='pke-street1_" + shop_number + "'>" + trimTrailing(this["Streetname"]) +"</span><br/>" +
                  "<span id='pke-zip_" + shop_number + "'>" + trimTrailing(this["ZipCode"]) +"</span>, <span id='pke-city_" + shop_number + "'>" + trimTrailing(this["CityName"]) + "</span>";
                   
          str = str + '<div class="' +shop_number + '" style="display:none">' + address + '</div>';
      });
      $(".pakke-shop-address").html(str);
  }

  
  $(document).ready(function() {
  populatePakkeShopSelect(pakke_shop_json_array.shop);
  populatePakkeShopAddresses();
  
});